<template>
    <base-section
      id="scan"
      space="56"
      class="grey lighten-4"
    >
      <v-container>
        <v-row justify="space-between">
          <v-col
            cols="12"
            md="12"
          >
            <base-business-info title="Cek Data" text="">
            </base-business-info>
            Data
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </template>
  
  <script>
    export default {
      name: 'SectionScan',
    }
  </script>
  